import { useState, useEffect } from "react"
import { useNavigate, useLocation } from "react-router"
import { toast } from "react-toastify"
import Server from "../../Shared/Server"
import Spinner from "../../Shared/Spinner"
import {InputField} from "../../Shared/InputField"
import SelectField from "../../Shared/SelectField"
import AsyncSelectField from "../../Shared/AsyncSelect"
import { discount_options } from "../../Shared/List"
import { status_list } from "../../Shared/List"

const UpdateUserForm = () => {
  const [errors, setErrors] = useState({})
  const [roleOption, setRoleOption] = useState([])
  const [statusOption, setStatusOption] = useState([
    {id: 1, name: "Active", key: "Active"},
    {id: 2, name: "Inactive", key: "Inactive"},
])
  const [employeeOption, setEmployeeOption] = useState([])
  const [discountOption, setDiscountOption] = useState([])
  const [isLoading, setIsLoading] = useState(false)

  const [formData, setFormData] = useState({
      username: "",
      email: "",
      role_id: "",
      status: "",
      public_id: "",
      employee_id: "",
      enable_discount: ""
  })
  const {username, email, role_id, status, public_id, employee_id, enable_discount} = formData

  const navigate = useNavigate()
  const location = useLocation()

  useEffect(() => {

    if (location.state){
        const {payload} = location.state
        setFormData({
            username: payload.username,
            email: payload.email,
            role_id: payload.role_id,
            public_id: payload.public_id,
            employee_id: payload.employee_id,
            enable_discount: discount_options.find(option => option.name === payload?.enable_discount)?.id || 1,
            status: discount_options.find(option => option.name === payload?.status)?.id || 1,
        })
    }

  }, [])

    const loadOptions = async (url, query, setOptions) => {
        
        setDiscountOption(discount_options.map(option => ({
            id: option.id, 
            key: option.key, 
            name: option.name
        })));


        try {
            const response = await Server.get(`/options/${url}`, {
                params: { q: query },
            });
            setOptions(response.data);
            return response.data;
        } catch (error) {
            return [];
        }
    };
  
  const onChange = (e) => {
      setFormData((prevState) => ({
          ...prevState,
          [e.target.name]: e.target.value
      }))
  }

  const onSubmit = (e) => {
      e.preventDefault()

      const enable_discount = discount_options[formData.enable_discount -1]?.name || "No"
      const status = statusOption[formData.status -1]?.name || "Active"

      const payload = {username, email, status, role_id, employee_id, enable_discount}
      updateUser(payload)
  }
  
  // update role
  const updateUser = async (payload) => {
      setIsLoading(true)
      try {
          const response = await Server.put(`/users/${public_id}`, payload)
          if (response.status === 200){
              navigate('/users')
              setIsLoading(false)
              toast.success('Successfully updated')
          }else{
              toast.error(response.data?.detail)
          }
      } catch (error) {
          setIsLoading(false)
          if(error.response.status === 401){
              navigate('/login')
          }else if (error.response.status === 422){
            setErrors({})
            error.response?.data?.detail.map((err) => (
                setErrors((prevState) => ({
                    ...prevState,
                    [err.loc[1]]: err.msg
                }))
            ))
        }else if (error.response.status === 403){
            toast.error(error.response.data.detail);
            navigate('/');
        }else {
            toast.error(error.response.data.detail);
        }
      }
  }

  if(isLoading){
      return <Spinner/>
  }

return (
  <>
    <div className="card">
            <div className="card-header p-2 bg-info text-white d-flex justify-content-center">
                <h3 className="card-title">Update User Form</h3>
            </div>
            <div className="card-body">
                <form onSubmit={onSubmit}>
                    <div className="row">
                        <div className="col-md-4">
                            <InputField
                                placeholder="UserName"
                                name="username"
                                type="text"
                                label="Name"
                                value={username}
                                onChange={onChange}
                                error={errors.username}
                            />
                        </div>
                        <div className="col-md-4">
                            <InputField
                                placeholder="Email Address"
                                name="email"
                                type="email"
                                label="Email"
                                value={email}
                                onChange={onChange}
                                error={errors.email}
                            />
                        </div>
                        <div className="col-md-4">
                            <SelectField
                                name="status"
                                label="Status"
                                value={parseInt(status)}
                                options={statusOption}
                                onChange={onChange}
                                error={errors.status}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-3">
                            <AsyncSelectField
                                name="role_id"
                                label="Role"
                                value={role_id}
                                onChange={onChange}
                                loadOptions={(query) => loadOptions('roles', query, setRoleOption)}
                                options={roleOption}
                                placeholder="Start typing to search..."
                                error={errors.role_id}
                            />
                        </div>
                        <div className="col-md-5">
                            <AsyncSelectField
                                name="employee_id"
                                label="Employee (Optional)"
                                value={employee_id}
                                onChange={onChange}
                                loadOptions={(query) => loadOptions('employees', query, setEmployeeOption)}
                                options={employeeOption}
                                placeholder="Start typing to search..."
                                error={errors.employee_id}
                            />
                        </div>
                        <div className="col-md-4">
                            <SelectField
                                name="enable_discount"
                                label="Discount"
                                value={parseInt(enable_discount)}
                                options={discountOption}
                                onChange={onChange}
                                error={errors.enable_discount}
                            />
                        </div>
                    </div>
                    <br/>
                    <div className="row">
                        <div className="col-md-12">
                            <input type="submit" className="btn btn-outline-info" value="Update User" style={{float: 'right'}}/>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <br/>
  </>
)
}

export default UpdateUserForm
